const getColumnClass = (count: number) => {
  if (count === 1) return 'colomn-12';
  if (count === 2) return 'colomn-6';
  return 'colomn-4'; // 3 or more
};
export { getColumnClass };
